<template>
  <div class="left-chart-1">
    <div class="lc1-header">运单运输情况</div>
    <div class="lc1-details">运单总数<span>{{ businessCount.totleCount}}</span></div>
    <dv-capsule-chart class="lc1-chart" :config="config" />
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
export default {
  name: 'LeftChart1',
  props: {
    businessCount: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    config () {
      return {
        showValue:true,
        data: [
          {
            name: '待发货',
            value: this.businessCount.waitCount
          },
          {
            name: '拒收',
            value: this.businessCount.refuseCount
          },
          {
            name: '在途中',
            value: this.businessCount.alreadyCount
          },
          {
            name: '已揽件',
            value: this.businessCount.packageCount
          },
          {
            name: '已签收',
            value: this.businessCount.signCount
          },
          {
            name: '总数',
            value: this.businessCount.totleCount
          }
        ],
        colors: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b', '#00baff'],
        unit: '件'
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less">
.left-chart-1 {
  width: 100%;
  height: 37%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 20px;
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc1-chart {
    flex: 1;
  }
}
</style>
